import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/app/App';
import '@/styles/index.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

/**
 * When SSR has already filled `#root`, we still mount with `createRoot` so the client
 * uses `BrowserRouter` (StaticRouter from SSR cannot drive the real URL bar). A future
 * upgrade would use `createBrowserRouter` + hydration data for true hydrateRoot parity.
 */
createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
